import React from "react";

const Razor_Intro = () => {
  return (
    <div className="tutorial-page">
      <h1>Razor Intro</h1>
      <p>This is the Razor Intro page content.</p>
    </div>
  );
};

export default Razor_Intro;
